



  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    name: 'AuthLayout',
    components: {},
    mixins: [],
  })
  export default class AuthLayout extends Vue {
    public created(): void {
      // on componenet created
    }
    public mounted(): void {
      // on componenet mounted
    }
  }
